module.exports = __webpack_public_path__ + "static/banner_sp-61cb350172e6d8298c2ff47fcc433103.png";